module.exports = __webpack_public_path__ + "img/download-on-the-app-store-apple.e374ae72.svg";